(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsDialogController', CurveLimitsDialogController);

    CurveLimitsDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', '$translate', 'entity', 'CurveLimits'];

    function CurveLimitsDialogController($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, $translate, entity, CurveLimits) {
        var vm = this;

        vm.curveLimits = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        var tenorLabels = [
            {value: 0, label: {en: "O/N", ro: "O/N"}},
            {value: 1, label: {en: "1 day", ro: "1 zi"}},
            {value: 7, label: {en: "1 week", ro: "1 săptămână"}},
            {value: 14, label: {en: "2 weeks", ro: "2 săptămâni"}},
            {value: 21, label: {en: "3 weeks", ro: "3 săptămâni"}},
            {value: 30, label: {en: "1 month", ro: "1 lună"}},
            {value: 61, label: {en: "2 months", ro: "2 luni"}},
            {value: 91, label: {en: "1 quarter", ro: "1 trimestru"}},
            {value: 183, label: {en: "2 quarters", ro: "2 trimestre"}},
            {value: 274, label: {en: "3 quarters", ro: "3 trimestre"}},
            {value: 365, label: {en: "1 year", ro: "1 an"}},
            {value: 457, label: {en: "5 quarters", ro: "5 trimestre"}},
            {value: 548, label: {en: "6 quarters", ro: "6 trimestre"}},
            {value: 640, label: {en: "7 quarters", ro: "7 trimestre"}},
            {value: 731, label: {en: "2 years", ro: "2 ani"}},
            {value: 1096, label: {en: "3 years", ro: "3 ani"}},
            {value: 1461, label: {en: "4 years", ro: "4 ani"}},
            {value: 1826, label: {en: "5 years", ro: "5 ani"}},
            {value: 2192, label: {en: "6 years", ro: "6 ani"}},
            {value: 2557, label: {en: "7 years", ro: "7 ani"}},
            {value: 2922, label: {en: "8 years", ro: "8 ani"}},
            {value: 3287, label: {en: "9 years", ro: "9 ani"}},
            {value: 3653, label: {en: "10 years", ro: "10 ani"}},
            {value: 4018, label: {en: "11 years", ro: "11 ani"}},
            {value: 4383, label: {en: "12 years", ro: "12 ani"}},
            {value: 4748, label: {en: "13 years", ro: "13 ani"}},
            {value: 5114, label: {en: "14 years", ro: "14 ani"}},
            {value: 5479, label: {en: "15 years", ro: "15 ani"}},
            {value: 5844, label: {en: "16 years", ro: "16 ani"}},
            {value: 6209, label: {en: "17 years", ro: "17 ani"}},
            {value: 6575, label: {en: "18 years", ro: "18 ani"}},
            {value: 6940, label: {en: "19 years", ro: "19 ani"}},
            {value: 7305, label: {en: "20 years", ro: "20 ani"}},
            {value: 7670, label: {en: "21 years", ro: "21 ani"}},
            {value: 8036, label: {en: "22 years", ro: "22 ani"}},
            {value: 8401, label: {en: "23 years", ro: "23 ani"}},
            {value: 8766, label: {en: "24 years", ro: "24 ani"}},
            {value: 9131, label: {en: "25 years", ro: "25 ani"}},
            {value: 9497, label: {en: "26 years", ro: "26 ani"}},
            {value: 9862, label: {en: "27 years", ro: "27 ani"}},
            {value: 10227, label: {en: "28 years", ro: "28 ani"}},
            {value: 10592, label: {en: "29 years", ro: "29 ani"}},
            {value: 10958, label: {en: "30 years", ro: "30 ani"}}
        ];
        vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
        vm.tenorLabels = tenorLabels.map(function (el) {
            return {value: el.value, label: el.label[vm.langKey]};
        });
        var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
            vm.tenorLabels = tenorLabels.map(function (el) {
                return {value: el.value, label: el.label[vm.langKey]};
            });
        });
        $rootScope.$on('$destroy', function () {
            if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                translateChangeSuccess();
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.curveLimits.id !== null) {
                CurveLimits.update(vm.curveLimits, onSaveSuccess, onSaveError);
            } else {
                CurveLimits.save(vm.curveLimits, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('moldovaYieldCurvesApp:curveLimitsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validFrom = false;
        vm.datePickerOpenStatus.validTo = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();
